import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "@phosphor-icons/react";

export default function LegalNotice() {
  return (
    <div data-testid="legal-page">
      {/* HERO */}
      <section className="bg-navy-deep text-white py-16 lg:py-20 noise-overlay relative">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm transition mb-6"
          >
            <ArrowLeft size={16} weight="bold" />
            Retour à l'accueil
          </Link>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/15">
            <ShieldCheck size={14} weight="duotone" className="text-purple-accent" />
            <span className="eyebrow text-purple-accent">Informations légales</span>
          </div>
          <h1 className="mt-6 font-serif text-4xl sm:text-5xl leading-[1.1] tracking-tight">
            Mentions <span className="font-serif-italic text-purple-accent">légales</span>
          </h1>
          <p className="mt-4 text-white/70 max-w-2xl leading-relaxed">
            Conformément aux dispositions légales en vigueur, les informations
            relatives à l'éditeur et à l'hébergeur du présent site sont précisées ci-dessous.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="bg-body-bg py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl border border-gray-100 shadow-subtle p-8 lg:p-12 space-y-10">

            <LegalBlock title="Éditeur du site">
              <p><strong>Madame Magalie Pichon</strong></p>
              <p>MP Advisory</p>
              <p className="text-slate-500 italic">Cabinet de recrutement indépendant spécialisé Sales &amp; IT</p>
            </LegalBlock>

            <LegalBlock title="Statut juridique">
              <p>Entreprise individuelle</p>
            </LegalBlock>

            <LegalBlock title="SIRET">
              <p className="font-mono tracking-wider">902 875 160 00027</p>
            </LegalBlock>

            <LegalBlock title="Code APE / NAF">
              <p>7022Z — Conseil pour les affaires et autres conseils de gestion</p>
            </LegalBlock>

            <LegalBlock title="Adresse du siège social">
              <p>Paris 75016</p>
            </LegalBlock>

            <LegalBlock title="Responsable de la publication">
              <p>Magalie Pichon</p>
            </LegalBlock>

            <LegalBlock title="Contact">
              <p>
                Email :{" "}
                <a href="mailto:rh@mpadvisory.fr" className="text-purple-accent hover:text-purple-accent-hover transition" data-testid="legal-email">
                  rh@mpadvisory.fr
                </a>
              </p>
              <p>
                Téléphone :{" "}
                <a href="tel:+33683175127" className="text-purple-accent hover:text-purple-accent-hover transition" data-testid="legal-phone">
                  06 83 17 51 27
                </a>
              </p>
              <p>
                Site internet :{" "}
                <a
                  href="https://mpadvisory.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-purple-accent hover:text-purple-accent-hover transition"
                  data-testid="legal-website"
                >
                  https://mpadvisory.fr
                </a>
              </p>
            </LegalBlock>

            <LegalBlock title="Hébergement">
              <p>
                Le site est hébergé par la plateforme utilisée pour son déploiement technique.
              </p>
              <p className="mt-3">
                Hébergeur :{" "}
                <strong>Emergent</strong>
              </p>
              <p>
                Site :{" "}
                <a
                  href="https://app.emergent.sh"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-purple-accent hover:text-purple-accent-hover transition"
                  data-testid="legal-host-link"
                >
                  https://app.emergent.sh
                </a>
              </p>
              <p className="mt-3 text-slate-500 italic text-[14px]">
                Les informations complètes relatives à l'hébergeur pourront être complétées ultérieurement si nécessaire.
              </p>
            </LegalBlock>

            <LegalBlock title="Propriété intellectuelle">
              <p>
                L'ensemble du contenu présent sur ce site (textes, images, logo, charte
                graphique) est la propriété exclusive de MP Advisory, sauf mention
                contraire. Toute reproduction, représentation ou diffusion, totale ou
                partielle, sans autorisation écrite préalable est interdite.
              </p>
            </LegalBlock>

            <LegalBlock title="Protection des données personnelles">
              <p>
                Les données collectées via les formulaires de contact sont traitées
                avec confidentialité et utilisées uniquement dans le cadre des
                échanges avec MP Advisory. Conformément au RGPD, vous disposez d'un
                droit d'accès, de rectification et de suppression de vos données.
                Pour toute demande, contactez :{" "}
                <a href="mailto:rh@mpadvisory.fr" className="text-purple-accent hover:text-purple-accent-hover transition">
                  rh@mpadvisory.fr
                </a>.
              </p>
            </LegalBlock>

          </div>
        </div>
      </section>
    </div>
  );
}

function LegalBlock({ title, children }) {
  return (
    <div className="border-b border-gray-100 pb-8 last:border-0 last:pb-0">
      <h2 className="eyebrow text-purple-accent mb-3">{title}</h2>
      <div className="space-y-1.5 text-[15px] text-slate-700 leading-relaxed">
        {children}
      </div>
    </div>
  );
}
